exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".fuel-surcharge .badge-success {\n  background-color: #28a745 !important; }\n\n.fuel-surcharge .badge-danger {\n  color: #dc3545; }\n\n.fuel-surcharge .badge-info {\n  background-color: #3289c0 !important; }\n\n.fuel-surcharge .fuel-surcharge-list-group {\n  margin-bottom: 10px !important; }\n\n.fuel-surcharge .fuel-surcharge-list {\n  padding: 6px 15px !important; }\n\n.fuel-surcharge .fuel-surcharge-pagination-section .pagination {\n  display: block !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/tnt_billing/components/fuel_surcharges/all/fuel_surcharges.all.scss
// module id = 1118
// module chunks = 1